<!-- 用户管理界面 -->
<template>
    <a-row :gutter="24" class="new-row">
        <a-col :md="collapsed?0: 5" :sm="24" class="new-col">
            <a-row :gutter="10" class="new-row">
                <a-card :bordered="false" class="new-tree-card">
                    <div style="background: #fff;padding-left:16px;height: 100%; margin-top: 5px">
                        <a-alert type="info" :showIcon="true">
                            <div slot="message">
                                {{ $t('当前选择：') }}<span v-if="this.currSelected.title">{{ getCurrSelectedTitle() }}</span>
                                <a v-if="this.currSelected.title" style="margin-left: 10px" @click="unselect">{{ $t('取消选择') }}</a>
                            </div>
                        </a-alert>
                        <div style="display: flex;margin-top: 10px;">
                            <a-input-search v-model="searchAreaValue" style="width:100%;margin-right: 5px;" allowClear :placeholder="$t('请输入区域名称')" />
                            <a-button type="default" @click="collapseAll">{{ $t('折叠') }}</a-button>
                        </div>
                        <!-- 树-->
                        <a-col :md="24" :sm="24" class="new-tree-col">
                            <template>
                                <a-spin tip="Loading..." :spinning="areaLoading">
                                    <!--
                <span style="user-select: none;">
                  <a-tree
                    ref="areaTree"
                    show-line
                    class="my-area-select-tree"
                    @select="onSelect"     
                    :selectedKeys="selectedKeys"
                    :treeData="areaTree"
                    :checkStrictly="checkStrictly"
                    :expandedKeys="iExpandedKeys"
                    :autoExpandParent="autoExpandParent"
                    defaultExpandParent
                    :filterTreeNode="filterTreeNode"
                    @expand="onExpand">
                    <template slot="title" slot-scope="{title}">
                      <span v-if="title.indexOf(searchAreaValue) > -1" :title="title">
                        {{title.substr(0, title.indexOf(searchAreaValue))}}
                        <span style="color: #32CD32">{{searchAreaValue}}</span>
                        {{title.substr(title.indexOf(searchAreaValue) + searchAreaValue.length)}}
                      </span>
                      <span v-else :title="title">{{title}}</span>
                    </template>
                  </a-tree>
                </span>
                -->
                                    <el-tree class="filter-tree" :data="areaTree" :props="defaultProps" :expand-on-click-node="false" :filter-node-method="filterNode" :check-on-click-node="true" :check-strictly="checkStrictly" :highlight-current="true" node-key="id" :current-node-key="currentNodeKey" :default-expanded-keys="iExpandedKeys" @node-click="nodeClick" ref="areaTree">
                                    </el-tree>
                                </a-spin>
                            </template>
                        </a-col>
                    </div>
                </a-card>
            </a-row>
        </a-col>
        <a-col :md="collapsed? 24: 19" :sm="24" style="position: relative;padding-left: 30px" class="new-col">
            <a-icon :type="collapsed ? 'caret-right':'caret-left'" @click="collapsed = !collapsed" class="area-collapsed"></a-icon>
            <a-card :bordered="false" class="new-table-card">
                <!-- 查询区域 -->
                <div class="table-page-search-wrapper">
                    <a-form layout="inline" @keyup.enter.native="searchQuery">
                        <a-row :gutter="24">
                            <a-col :xl="6" :lg="7" :md="8" :sm="24">
                                <a-form-item :label="$t('表编号')">
                                    <j-input :placeholder="$t('表编号模糊查询')" v-model="queryParam.meterId"></j-input>
                                </a-form-item>
                            </a-col>
                            <a-col :xl="6" :lg="7" :md="8" :sm="24">
                              <a-form-item :label="$t('表口径')">
                                <a-select v-model="queryParam.meterCaliber" :placeholder="$t('请选择表口径')">
                                  <a-select-option v-for="data in userCaliberList" :key="data.mtCaliber" :value="data.mtCaliber">
                                    DN{{data.mtCaliber}}
                                  </a-select-option>
                                </a-select>
                              </a-form-item>
                            </a-col>
                            <a-col :xl="6" :lg="7" :md="8" :sm="24">
                                <a-form-item :label="$t('用户编号')">
                                    <j-input :placeholder="$t('用户编号模糊查询')" v-model="queryParam.userId"></j-input>
                                </a-form-item>
                            </a-col>
                            <a-col :xl="6" :lg="7" :md="8" :sm="24">
                                <a-form-item :label="$t('用户姓名')">
                                    <j-input :placeholder="$t('用户姓名模糊查询')" v-model="queryParam.userName"></j-input>
                                </a-form-item>
                            </a-col>
                            <template v-if="toggleSearchStatus">
                                <a-col :xl="6" :lg="7" :md="8" :sm="24">
                                    <a-form-item :label="$t('用户地址')">
                                        <j-input :placeholder="$t('用户地址模糊查询')" v-model="queryParam.userAddr"></j-input>
                                    </a-form-item>
                                </a-col>
                                <a-col :xl="6" :lg="7" :md="8" :sm="24">
                                    <a-form-item :label="$t('用户手机号')">
                                        <j-input :placeholder="$t('用户手机号模糊查询')" v-model="queryParam.userPhone"></j-input>
                                    </a-form-item>
                                </a-col>
                                <a-col :xl="6" :lg="7" :md="8" :sm="24">
                                    <a-form-item :label="$t('册号')">
                                        <a-input :placeholder="$t('请输入册号')" v-model="queryParam.mtVolumeNo"></a-input>
                                    </a-form-item>
                                </a-col>
                                <a-col :xl="6" :lg="7" :md="8" :sm="24">
                                    <a-form-item :label="$t('用户状态')">
                                        <a-select v-model="queryParam.userState" :placeholder="$t('请选择用户状态')" :getPopupContainer="triggerNode => {return triggerNode.parentNode || document.body;}">
                                            <a-select-option :value="1">
                                                {{ $t('已激活') }}
                                            </a-select-option>
                                            <a-select-option :value="0">
                                                {{ $t('未激活') }}
                                            </a-select-option>
                                        </a-select>
                                    </a-form-item>
                                </a-col>

                                <a-col :xl="6" :lg="7" :md="8" :sm="24">
                                    <a-form-item :label="$t('是否制卡')">
                                        <a-select v-model="queryParam.userHasCard" :placeholder="$t('请选择是否制卡')" :getPopupContainer="triggerNode => {return triggerNode.parentNode || document.body;}">
                                            <a-select-option :value="1">
                                                {{ $t('已制卡') }}
                                            </a-select-option>
                                            <a-select-option :value="0">
                                                {{ $t('未制卡') }}
                                            </a-select-option>
                                        </a-select>
                                    </a-form-item>
                                </a-col>

                                <a-col :xl="6" :lg="7" :md="8" :sm="24">
                                    <a-form-item :label="$t('用户价格名称')">
                                        <a-select :showSearch="true" option-filter-prop="children" v-model="queryParam.userPriceId" :placeholder="$t('请选择用户价格名称')">
                                            <a-select-option v-for="data in userPriceCode" :key="data.id" :value="data.id">
                                                {{data.wtName}}
                                            </a-select-option>
                                        </a-select>
                                    </a-form-item>
                                </a-col>
                                <a-col :xl="6" :lg="7" :md="8" :sm="24">
                                    <a-form-item :label="$t('查询激活时间')">
                                        <a-range-picker v-model="date" format="YYYY-MM-DD" :placeholder="[$t('查询起始时间'), $t('查询结束时间')]" @change="onDateRangeChange" @ok="onOk" />
                                    </a-form-item>
                                </a-col>
                                <a-col :xl="6" :lg="7" :md="8" :sm="24">
                                    <a-form-item :label="$t('查询建档时间')">
                                        <a-range-picker v-model="createDate" format="YYYY-MM-DD" :placeholder="[$t('查询起始时间'), $t('查询结束时间')]" @change="onCreateDateRangeChange" @ok="onOk" />
                                    </a-form-item>
                                </a-col>
                                <a-col :xl="6" :lg="7" :md="8" :sm="24">
                                    <a-form-item :label="$t('证像采集')">
                                        <j-dict-select-tag v-model="queryParam.isCertified" :placeholder="$t('请选择是否证像采集')" dictCode="yn" style="width:100%" />
                                    </a-form-item>
                                </a-col>
                                <!-- <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="用户用水状态">
                <j-dict-select-tag v-model="queryParam.userState" placeholder="请选择用水状态" dictCode="user_state" style="width:100%"/>
              </a-form-item>
            </a-col> -->
                            </template>
                            <a-col :xl="6" :lg="7" :md="8" :sm="24">
                                <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                                    <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
                                    <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
                                    <a @click="handleToggleSearch" style="margin-left: 8px">
                                        {{ toggleSearchStatus ? $t('收起') : $t('展开') }}
                                        <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />
                                    </a>
                                </span>
                            </a-col>
                        </a-row>
                    </a-form>
                </div>
                <!-- 操作按钮区域 -->
                <div class="table-operator">
                    <a-button @click="handleAdd()" type="primary" icon="plus" v-has="'meteruser:add'">{{ $t('新建档案') }}</a-button>
                    <a-button @click="readcard(1)" type="primary" icon="shake" v-has="'meteruser:optcard'">{{ $t('卡操作') }}</a-button>
                    <a-button type="primary" icon="download" @click="handleExportXls($t('用户档案'))">{{ $t('导出') }}</a-button>
                    <a-dropdown v-if="selectedRowKeys.length > 0">
                        <a-menu slot="overlay">
                            <a-menu-item key="1" @click="batchDel"><a-icon type="delete" />{{ $t('删除') }}</a-menu-item>
                            <a-menu-item key="2" @click="batchStop"><a-icon type="pause-circle" />{{ $t('报停') }}</a-menu-item>
                        </a-menu>
                        <a-button style="margin-left: 8px" v-has="'meteruser:batchdelete'"> {{ $t('批量操作') }} <a-icon type="down" /></a-button>
                    </a-dropdown>
                </div>
                <!-- table区域-begin -->
                <div class="table-fixed">
                    <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;" v-if="selectedRowKeys.length > 0">
                        <i class="anticon anticon-info-circle ant-alert-icon"></i> {{ $t('已选择 {count} 项', { count: selectedRowKeys.length }) }}
                        <a style="margin-left: 24px" @click="onClearSelected">{{ $t('清空') }}</a>
                        <span style="float:right;">
                            <a @click="loadData()"><a-icon type="sync" />{{ $t('刷新') }}</a>
                            <a-popover :title="$t('自定义列')" trigger="click" placement="leftBottom">
                                <template slot="content">
                                    <a-checkbox-group @change="onColSettingsChange" v-model="settingColumns" :defaultValue="settingColumns">
                                        <a-row>
                                            <template v-for="item in defColumns">
                                                <template v-if="item.key!='rowIndex'&& item.dataIndex!='action'">
                                                    <a-col :span="12" :key="item.key"><a-checkbox :value="item.dataIndex">{{ item.title }}</a-checkbox></a-col>
                                                </template>
                                            </template>
                                        </a-row>
                                    </a-checkbox-group>
                                </template>
                            </a-popover>
                        </span>
                    </div>
                    <a-table ref="table" size="middle" :scroll="{ x: true }" bordered rowKey="id" :columns="columns" :dataSource="dataSource" :pagination="ipagination" :loading="loading" :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}" :components="drag(columns)" @change="handleTableChange">
                        <span slot="userId" slot-scope="text, record">
                            <a @click="handleDetail(record)">{{text}}</a>
                        </span>
                        <div slot="filterDropdown">
                            <a-card>
                                <a-checkbox-group @change="onColSettingsChange" v-model="settingColumns" :defaultValue="settingColumns">
                                    <a-row>
                                        <template v-for="item in defColumns">
                                            <template v-if="item.key!='rowIndex'&& item.dataIndex!='action'">
                                                <a-col :span="12" :key="item.key">
                                                    <a-checkbox :value="item.dataIndex">{{ item.title }}</a-checkbox>
                                                </a-col>
                                            </template>
                                        </template>
                                    </a-row>
                                </a-checkbox-group>
                            </a-card>
                        </div>
                        <a-icon slot="filterIcon" type='down' :style="{ fontSize:'12px',color: '#108ee9'}" />
                        <template slot="htmlSlot" slot-scope="text">
                            <div v-html="text"></div>
                        </template>
                        <template slot="userStateSlot" slot-scope="text">
                            <a-button :class="text == 1?'normalbg-status':text == 0?'unactivebg-status':''">
                                {{text==1?$t('已激活'):text==0?$t('未激活'):''}}
                            </a-button>
                        </template>
                        <template slot="imgSlot" slot-scope="text">
                            <span v-if="!text" style="font-size: 12px;font-style: italic;">{{ $t('无图片') }}</span>
                            <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;" />
                        </template>
                        <template slot="fileSlot" slot-scope="text">
                            <span v-if="!text" style="font-size: 12px;font-style: italic;">{{ $t('无文件') }}</span>
                            <a-button v-else :ghost="true" type="primary" icon="download" size="small" @click="downloadFile(text)">
                                {{ $t('下载') }}
                            </a-button>
                        </template>
                        <span slot="userAccount" slot-scope="text, record">
                            <a-tag style="font-size: 14px" :color="record.userAccountNum==null?'':record.userAccountNum<=0?'red': record.wtAlarmMoney<record.userAccountNum?'green':'orange'">{{record.userAccountNum}}</a-tag>
                        </span>
                        <span slot="wtPriceSlot" slot-scope="text, record" :title="record.wtName?record.wtName+'('+record.wtTotalPrice+')':''">
                            <span v-if="record.wtName"> {{record.wtName}}({{record.wtTotalPrice?record.wtTotalPrice + $t('元'): '--'}})</span>
                            <span v-else>--</span>
                        </span>
                        <span slot="importantFlag" slot-scope="text, record">
                            <a-rate v-model="record.importantFlag" :count="1" @change="changeImportantFlag(record)" />
                        </span>

                        <span slot="action" slot-scope="text, record" class="action">
                            <a @click="handleEdit(record)" v-has="'meteruser:edit'">{{ $t('编辑') }}</a>
                            <a :disabled="record.userState !== 0 || record.userId == null" @click="activate(record)" v-has="'meteruser:active'">{{ $t('激活') }}</a>
                            <a @click="readcard(2,record)" :disabled="record.userState === 0||record.meterType!=='WN100'">{{ $t('制卡') }}</a>
                            <a-dropdown>
                                <a class="ant-dropdown-link">{{ $t('更多') }} <a-icon type="down" /></a>
                                <a-menu slot="overlay">
                                    <!-- <a-menu-item>
                <a @click="handleQRcod(record)" :disabled="record.userState == 0||record.userState==null" :style="{color: record.userState !== 0?'rgba(0, 0, 0, 0.65)':'rgba(0, 0, 0, 0.25)'}">生成二维码</a>
              </a-menu-item> -->
                                    <a-menu-item>
                                        <a @click="handleDetail(record)">{{ $t('用户详情') }}</a>
                                    </a-menu-item>
                                    <a-menu-item v-has="'meteruser:changeuser'">
                                        <a @click="assigned(record)" :disabled="record.userState == 0||record.userState==null" :style="{color: record.userState !== 0?'rgba(0, 0, 0, 0.65)':'rgba(0, 0, 0, 0.25)'}">{{ $t('用户过户') }}</a>
                                    </a-menu-item>
                                    <a-menu-item v-has="'meteruser:changemeter'">
                                        <a @click="tableOfStrings(record)" :disabled="record.userState == 0||record.userState==null" :style="{color: record.userState !== 0?'rgba(0, 0, 0, 0.65)':'rgba(0, 0, 0, 0.25)'}">{{ $t('用户换表') }}</a>
                                    </a-menu-item>
                                    <a-menu-item v-has="'meteruser:changeprice'">
                                        <a @click="changePrice(record)" :disabled="record.userState == 0||record.userState==null" :style="{color: record.userState !== 0?'rgba(0, 0, 0, 0.65)':'rgba(0, 0, 0, 0.25)'}">{{ $t('用户调价') }}</a>
                                    </a-menu-item>
                                    <a-menu-item>
                                        <a @click="familyMembers(record)" :style="{color: record.userState !== 0?'rgba(0, 0, 0, 0.65)':'rgba(0, 0, 0, 0.25)'}">{{ $t('家庭成员') }}</a>
                                    </a-menu-item>
                                    <a-menu-item>
                                        <a @click="tenantInformation(record)" :style="{color: record.userState !== 0?'rgba(0, 0, 0, 0.65)':'rgba(0, 0, 0, 0.25)'}">{{ $t('租户信息') }}</a>
                                    </a-menu-item>
                                    <a-menu-item>
                                        <a @click="userContract(record)" :style="{color: record.userState !== 0?'rgba(0, 0, 0, 0.65)':'rgba(0, 0, 0, 0.25)'}">{{ $t('用户合同') }}</a>
                                    </a-menu-item>
                                    <!--
              <a-menu-item>
                <a @click="replenishment(record)">补水</a>
              </a-menu-item>
              <a-menu-item>
                <a @click="returnPremium(record)">退费</a>
              </a-menu-item>
              <a-menu-item>
                <a @click="revocation(record)">撤销</a>
              </a-menu-item>
              -->
                                    <a-menu-item v-has="'meteruser:delete'">
                                        <a @click="handleDelete(record)">{{ $t('删除用户') }}</a>
                                        <!-- <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm> -->
                                    </a-menu-item>
                                    <a-menu-item v-has="'meteruser:stopreporting'">
                                        <a @click="handleStop(record)" :disabled="record.userState == 0||record.userState==null" :style="{color: record.userState !== 0?'rgba(0, 0, 0, 0.65)':'rgba(0, 0, 0, 0.25)'}">{{ $t('用户报停') }}</a>
                                    </a-menu-item>
                                    <a-menu-item v-has="'meteruser:accountcancellation'">
                                        <a @click="handleCancellation(record)" :disabled="record.userState == 0||record.userState==null" :style="{color: record.userState !== 0?'rgba(0, 0, 0, 0.65)':'rgba(0, 0, 0, 0.25)'}">{{ $t('用户销户') }}</a>
                                    </a-menu-item>
                                </a-menu>
                            </a-dropdown>
                        </span>
                    </a-table>
                </div>
                <meter-userinfo-modal ref="modalForm" @ok="modalFormOk"></meter-userinfo-modal>
                <meter-Particulars-modal ref="ParticularsForm" @ok="modalFormOk"></meter-Particulars-modal>
                <meter-assigned-modal ref="assignedForm" @ok="modalFormOk"></meter-assigned-modal>
                <meter-openAccount-modal ref="openAccountForm" @ok="modalFormOk"></meter-openAccount-modal>
                <meter-tableOfStrings-modal ref="tableOfStringsForm" @ok="modalFormOk"></meter-tableOfStrings-modal>
                <meter-Activate-modal ref="ActivateForm" @ok="modalFormOkActive"></meter-Activate-modal>
                <meter-pay-modal ref="payForm" @ok="modalFormOk"></meter-pay-modal>
                <meter-replenishment-modal ref="replenishmentForm" @ok="modalFormOk"></meter-replenishment-modal> <!--补水-->
                <meter-rfidToolMgr-modal ref="rfidToolMgrForm" @ok="rfidToolMgrFormOk"></meter-rfidToolMgr-modal>
                <meter-returnPremium-modal ref="returnPremiumForm" @ok="modalFormOk"></meter-returnPremium-modal> <!--退费-->
                <meter-revocation-modal ref="revocationForm" @ok="modalFormOk"></meter-revocation-modal> <!--撤销-->
                <meter-userinfo-changePrice-modal ref="meterUserinfoChangePriceForm" @ok="modalFormOk"></meter-userinfo-changePrice-modal><!--调价-->
                <meter-user-batch-adjust-price-modal ref="meterUserBatchAdjustPriceModal" @ok="modalFormOk"></meter-user-batch-adjust-price-modal>
                <family-members-table-modal ref="familyMembersRef"></family-members-table-modal><!--家庭成员-->
                <tenant-information-table-modal ref="tenantInformationRef"></tenant-information-table-modal><!--租户信息-->
                <user-contract-table-modal ref="userContractRef"></user-contract-table-modal><!--用户合同-->
                <!-- 生成二维码 -->
                <a-modal :title="$t('水表充值二维码')" :visible="qrcodeVisible" :closable="false" width="248px">
                    <div class="qrcodeInfo">{{ $t('用户编号：') }}{{qrcodeInfo.userId}}</div>
                    <div class="qrcodeInfo">{{ $t('用户姓名：') }}{{qrcodeInfo.userName}}</div>
                    <div ref="qrCodeDiv" v-if="qrcodeVisible"></div>
                    <template slot="footer">
                        <a-button @click="handleCancel">{{ $t('关闭') }}</a-button>
                    </template>
                </a-modal>
            </a-card>
        </a-col>
    </a-row>
</template>
<script>
import { getAction, deleteAction, postAction,putAction } from '@/api/manage'
import '@/assets/less/TableExpand.less'
import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { AreaChoosetMixin } from '@/mixins/AreaChooseMixin'
import MeterUserinfoModal from './modules/MeterUserinfoModal'
import MeterAssignedModal from './modules/MeterAssignedModal'
import MeterOpenAccountModal from './modules/MeterOpenAccountModal'
import MeterTableOfStringsModal from './modules/MeterTableOfStringsModal'
import MeterActivateModal from './modules/MeterActivateModal'
import MeterParticularsModal from './modules/MeterParticularsModal'
import MeterPayModal from './modules/MeterPayModal'
import MeterReplenishmentModal from './modules/MeterReplenishmentModal'
import MeterReturnPremiumModal from './modules/MeterReturnPremiumModal'
import MeterRevocationModal from './modules/MeterRevocationModal'
import MeterUserinfoChangePriceModal from './modules/MeterUserinfoChangePriceModal'
import MeterRfidToolMgrModal from '../oldMeterCompatibleManagement/modules/RfidToolMgrModal'
import MeterUserBatchAdjustPriceModal from './modules/MeterUserBatchAdjustPriceModal'
import FamilyMembersTableModal from './modules/FamilyMembersTableModal'
import TenantInformationTableModal from './modules/TenantInformationTableModal'
import UserContractTableModal from './modules/UserContractTableModal'
import TableDragResize from '@/mixins/TableDragResize'
import JInput from '@/components/jeecg/JInput'
import configService from '@/utils/service/config.service'
import { listSize } from '@/utils/util'
import Vue from 'vue'
import QRCode from 'qrcode'
export default {
    name: 'MeterUserInfoList',
    mixins: [JeecgListMixin, mixinDevice, AreaChoosetMixin, TableDragResize],
    components: {
        MeterUserinfoModal,
        MeterAssignedModal,
        MeterOpenAccountModal,
        MeterTableOfStringsModal,
        MeterActivateModal,
        MeterParticularsModal,
        MeterPayModal,
        MeterReplenishmentModal,
        MeterReturnPremiumModal,
        MeterRevocationModal,
        MeterRfidToolMgrModal,
        MeterUserinfoChangePriceModal,
        MeterUserBatchAdjustPriceModal,
        FamilyMembersTableModal,
        TenantInformationTableModal,
        UserContractTableModal,
        JInput,
    },
    data() {
        return {
            //表头
            columns: [],
            collapsed: false,
            //列设置
            settingColumns: [],
            data: [],
            visible: false,
            userPriceCode: [], // 价格编码
            description: 'meter_userinfo管理页面',
            url: {
                list: "/jeecg-charge/meter/meterUserinfo/list",
                delete: "/jeecg-charge/meter/meterUserinfo/delete",
                deleteBatch: "/jeecg-charge/meter/meterUserinfo/deleteBatch",
                exportXlsUrl: "/jeecg-charge/meter/meterUserinfo/exportXls", //导出接口
                importExcelUrl: "jeecg-charge/meter/meterUserinfo/importExcel",
                UserRecordList: "/jeecg-charge/meter/meterUserPayRecord/list",
                userPriceCode: "/jeecg-charge/meter/meterPriceinfo/list",
                stopUserByIds: "/jeecg-charge/meter/meterUserinfo/stopUserByIds",
                logoutUserByIds: "/jeecg-charge/meter/meterUserinfo/logoutUserByIds",
                edit: "/jeecg-charge/meter/meterUserinfo/edit",
                userCaliberList:"/jeecg-charge/meter/meterCaliber/list",  //表口径请求地址
            },
            dictOptions: {},
            dateType: 2,
            createDate: [],
            qrcodeVisible: false,
            qrcodeInfo: {},
            userCaliberList:[],  // 表口径
        }
    },
    computed: {
        importExcelUrl: function () {
            return `${configService.apiUrl}/${this.url.importExcelUrl}`;
        },
        // i18n：表头使用 computed 以响应语言切换
        defColumns() {
            return [
                {
                    title: '#',
                    dataIndex: '',
                    key: 'rowIndex',
                    width: 60,
                    align: "center",
                    customRender: function (t, r, index) {
                        return parseInt(index) + 1;
                    },
                    scopedSlots: {
                        filterDropdown: 'filterDropdown',
                        filterIcon: 'filterIcon'
                    }
                },{
                    title: this.$t('重点关注'),
                    align: "center",
                    dataIndex: 'importantFlag',
                    width: 100,
                    scopedSlots: { customRender: 'importantFlag' },
                    ellipsis: true
                }, {
                    title: this.$t('用户编号'),
                    align: "center",
                    // sorter: true,
                    dataIndex: 'userId',
                    width: 150,
                    scopedSlots: { customRender: 'userId' },
                    ellipsis: true
                }, {
                    title: this.$t('用户状态'),
                    align: "center",
                    dataIndex: 'userState',
                    scopedSlots: { customRender: 'userStateSlot' },
                    width: 100,
                    ellipsis: true
                },
                // {
                //   title:'区域名称',
                //   align:"center",
                //   dataIndex:'userAreaName',
                //   width:200,
                //   ellipsis: true
                // },
                {
                    title: this.$t('用户姓名'),
                    align: "center",
                    dataIndex: 'userName',
                    width: 150,
                    ellipsis: true
                }, {
                    title: this.$t('表编号'),
                    align: "center",
                    dataIndex: 'meterId',
                    width: 150,
                    ellipsis: true
                    // sorter: (a, b) => a.meterId - b.meterId,
                },
                // {
                //   title:'册号',
                //   align:"center",
                //   dataIndex: 'mtVolumeNo',
                //   width: 150
                // },
                {
                    title: this.$t('表类型'),
                    align: "center",
                    dataIndex: 'meterTypeName',
                    width: 100,
                    ellipsis: true
                },{
                    title: this.$t('表口径'),
                    align: "center",
                    dataIndex: 'mtCaliber',
                    customRender: function (t, r, index) {
                      return 'DN' + t
                    },
                    width: 100,
                    ellipsis: true
                }, {
                    title: this.$t('用户地址'),
                    align: "center",
                    dataIndex: 'userAddr',
                    customRender: function (t, r, index) {
                        if (r.userAreaName) {
                            let i = r.userAreaName.indexOf('-');
                            return r.userAreaName.slice(i + 1, r.userAreaName.length) + '-' + t;
                        } else {
                            return t
                        }
                    },
                    width: 200,
                    ellipsis: true,
                }, {
                    title: this.$t('当前余额(元)'),
                    align: "center",
                    dataIndex: 'userAccountNum',
                    width: 150,
                    ellipsis: true,
                    scopedSlots: { customRender: 'userAccount' }
                }, {
                    title: this.$t('价格信息'),
                    align: "center",
                    dataIndex: 'wtPrice',
                    width: 150,
                    ellipsis: true,
                    scopedSlots: { customRender: 'wtPriceSlot' },
                }, {
                    title: this.$t('建档时间'),
                    // sorter: true,
                    align: "center",
                    dataIndex: 'createTime',
                    width: 150,
                    ellipsis: true
                }, {
                    title: this.$t('激活时间'),
                    // sorter: true,
                    align: "center",
                    dataIndex: 'userActivateTime',
                    width: 150,
                    ellipsis: true
                }, {
                    title: this.$t('是否报停'),
                    align: "center",
                    dataIndex: 'isStop',
                    customRender: (t, r, index) => {
                        if (t == 1) {
                            return this.$t('是')
                        } else {
                            return this.$t('否')
                        }
                    },
                    width: 100,
                    ellipsis: true
                }, {
                    title: this.$t('是否销户'),
                    align: "center",
                    dataIndex: 'isLogout',
                    customRender: (t, r, index) => {
                        if (t == 1) {
                            return this.$t('是')
                        } else {
                            return this.$t('否')
                        }
                    },
                    width: 100,
                    ellipsis: true
                }, {
                    title: this.$t('操作'),
                    dataIndex: 'action',
                    align: "center",
                    fixed: "right",
                    width: 190,
                    scopedSlots: { customRender: 'action' }
                }
            ]
        },
    },
    methods: {
        queryUserCaliberList() {   //表口径请求
          let params = {}
          params.pageNo = 1;
          params.pageSize = listSize;
          params.column = 'mtCaliber';
          params.order = 'asc';
          getAction(this.url.userCaliberList, params).then((res) => {
            if(res.success){
              this.userCaliberList = res.result.records;
            }
          }) 
        },
        handleDelete(record) {
            var that = this;
            that.$confirm({
                title: this.$t('确定删除吗?'),
                content: h => <div style="color:red;">{this.$t('将会删除')}<a>{record.userName}</a>{this.$t('在平台中的用户管理信息、表具信息、实时数据信息、上报信息的数据，请慎重操作!')}</div>,
                onOk() {
                    let params = {}
                    params.id = record.id;
                    deleteAction(that.url.delete, params).then((res) => {
                        if (res.success) {
                            that.$message.success(res.message);
                            that.loadData();
                        } else {
                            that.$message.warning(res.message);
                        }
                    });
                },
                onCancel() {
                    console.log('Cancel');
                },
                class: 'test',
            });
        },
        //列设置更改事件
        onColSettingsChange(checkedValues) {
            var key = this.$route.name + ":colsettings";
            Vue.ls.set(key, checkedValues, 7 * 24 * 60 * 60 * 1000)
            this.settingColumns = checkedValues;
            const cols = this.defColumns.filter(item => {
                if (item.key == 'rowIndex' || item.dataIndex == 'action') {
                    return true
                }
                if (this.settingColumns.includes(item.dataIndex)) {
                    return true
                }
                return false
            })
            this.columns = cols;
        },
        initColumns() {
            //权限过滤（列权限控制时打开，修改第二个参数为授权码前缀）
            //this.defColumns = colAuthFilter(this.defColumns,'testdemo:');
            var key = this.$route.name + ":colsettings";
            let colSettings = Vue.ls.get(key);
            if (colSettings === null || colSettings == undefined) {
                let allSettingColumns = [];
                this.defColumns.forEach(function (item, i, array) {
                    allSettingColumns.push(item.dataIndex);
                })
                this.settingColumns = allSettingColumns;
                this.columns = this.defColumns;
            } else {
                this.settingColumns = colSettings;
                const cols = this.defColumns.filter(item => {
                    if (item.key == 'rowIndex' || item.dataIndex == 'action') {
                        return true;
                    }
                    if (colSettings.includes(item.dataIndex)) {
                        return true;
                    }
                    return false;
                })
                this.columns = cols;
            }
        },
        queryUserPriceCode() {
            let params = {}
            params.pageNo = 1;
            params.pageSize = listSize;
            getAction(this.url.userPriceCode, params).then((res) => {
                if (res.success) {
                    this.userPriceCode = res.result.records;
                    console.log(this.userPriceCode);
                }
            })
        },
        toggleModal(record) {    // 缴费页面点击跳转
            this.$refs.payForm.edit(record)
            this.$refs.payForm.title = this.$t('缴费')
        },
        replenishment(record) { //补水界面点击跳转
            this.$refs.replenishmentForm.edit(record)
            this.$refs.replenishmentForm.title = this.$t('补水')
        },
        returnPremium(record) { //退费界面点击跳转
            this.$refs.returnPremiumForm.edit(record)
            this.$refs.returnPremiumForm.title = this.$t('退费')
        },
        revocation(record) { //撤销界面点击跳转
            this.$refs.revocationForm.edit(record)
            this.$refs.revocationForm.title = this.$t('撤销')
        },
        handleAdd() {
            this.$refs.modalForm.add(JSON.parse(JSON.stringify(this.currSelected)))
            this.$refs.modalForm.title = this.$t('新增用户信息')
        },
        readcard(arg, record) { //读卡
            console.log(arg);
            console.log(record);

            if (arg == 1) {
                this.$refs.rfidToolMgrForm.title = this.$t('卡操作')
                this.$refs.rfidToolMgrForm.edit(arg);
            } else {
                this.$refs.rfidToolMgrForm.title = this.$t('制卡')
                this.$refs.rfidToolMgrForm.edit(arg, record);
            }
        },
        assigned(record) {   //过户界面点击跳转
            this.$refs.assignedForm.edit(record)
            this.$refs.assignedForm.title = this.$t('过户')
        },
        tableOfStrings(record) { //换表界面点击跳转
            this.$refs.tableOfStringsForm.edit(record)
            this.$refs.tableOfStringsForm.title = this.$t('换表')
        },
        openAccount(record) { //开户界面点击跳转
            this.$refs.openAccountForm.edit(record)
            this.$refs.openAccountForm.title = this.$t('开户')
        },
        activate(record) {
            this.$refs.ActivateForm.edit(record)
            this.$refs.ActivateForm.title = this.$t('激活')
        },
        handleDetail(record) {
            this.$refs.ParticularsForm.edit(record);
            this.$refs.ParticularsForm.title = this.$t("详情");
            this.$refs.ParticularsForm.disableSubmit = true;
        },
        changePrice(record) {
            this.$refs.meterUserinfoChangePriceForm.edit(record)
            this.$refs.meterUserinfoChangePriceForm.title = this.$t('调价')
        },
        familyMembers(record) {
            this.$nextTick(() => {
                this.$refs.familyMembersRef.init(record);
            })
        },
        tenantInformation(record) {
            this.$nextTick(() => {
                this.$refs.tenantInformationRef.init(record);
            })
        },
        userContract(record) {
            this.$nextTick(() => {
                this.$refs.userContractRef.init(record);
            })
        },
        rfidToolMgrFormOk() {
        },
        handleBatchAdjustPrice() {
            this.$refs.meterUserBatchAdjustPriceModal.add()
            this.$refs.meterUserBatchAdjustPriceModal.title = this.$t('批量调价')
        },
        onOk(value) {
            console.log('onOk: ', value);
        },
        onCreateDateRangeChange(value, dateStrings) {
            if (dateStrings[0] != '' && dateStrings[1] != '') {
                if (this.dateType == 1) {
                    this.queryParam.startCreateDate = dateStrings[0] + ' 00:00:00';
                    this.queryParam.endCreateDate = dateStrings[1] + ' 23:59:59';
                } else {
                    this.queryParam.startCreateDate = dateStrings[0];
                    this.queryParam.endCreateDate = dateStrings[1];
                }
            } else {
                if (this.queryParam['startCreateDate']) {
                    delete this.queryParam['startCreateDate']
                }
                if (this.queryParam['endCreateDate']) {
                    delete this.queryParam['endCreateDate']
                }
            }
        },
        searchReset() {
            this.queryParam = {}
            this.resetAareaData()
            this.date = []
            this.createDate = [];
            this.loadData(1);
        },
        // 生成二维码
        handleQRcod(row) {
            let that = this;
            that.qrcodeVisible = true;
            this.$nextTick(() => {
                that.qrcodeInfo = row;
                // http://120.70.101.150:9999
                QRCode.toCanvas(`http://172.16.8.235:8080/pages/payManagement/payMoneyMgr?userName=${row.userName}&userId=${row.userId}&meterId=${row.meterId}&userPhone=${row.userPhone}&userAddr=${row.userAddr}&userAccountNum=${row.userAccountNum}`, {
                    color: {
                        dark: '#1890FF',
                    },
                    width: 200,
                    margin: 0
                }, (error, canvas) => {
                    if (error) {
                        this.$message.error(this.$t('生成二维码失败'));
                        return
                    }
                    that.$refs.qrCodeDiv.appendChild(canvas);
                })
            })
        },
        handleCancel() {
            this.qrcodeVisible = false;
        },
        // 激活时生成二维码
        modalFormOkActive(row) {
            this.modalFormOk();
            this.handleQRcod(row);
        },
        // 报停
        handleStop(row) {
            let that = this;
            this.$confirm({
                title: this.$t('提示'),
                content: this.$t('停表后，该表用户信息将不在系统内显示，只有报停恢复后，才恢复正常使用。确定停表？'),
                onOk() {
                    that.loading = true;
                    let paramsList = [
                        {
                            meterId: row.meterId,
                            meterType: row.meterType,
                            meterTypeName: row.meterTypeName,
                            operateType: 0,
                            userId: row.userId,
                            userKeyId: row.id,
                            userName: row.userName,
                            wtPriceName: `${row.wtName}(${row.wtTotalPrice}${that.$t('元')})`,
                            userAreaId: row.userAreaId
                        }
                    ];
                    postAction(that.url.stopUserByIds, { meterStopRecordDTOList: paramsList }).then(res => {
                        if (res.success) {
                            that.$message.success(that.$t("报停成功"));
                            that.loadData();
                        } else {
                            that.$message.warning(res.message);
                        }
                    }).finally(() => {
                        that.loading = false;
                    });
                },
                onCancel() {
                    console.log('Cancel');
                },
            });
        },
        // 批量报停
        batchStop() {
            var that = this;
            this.$confirm({
                title: this.$t("提示"),
                content: this.$t("停表后，该表用户信息将不在系统内显示，只有报停恢复后，才恢复正常使用。确定停表？"),
                onOk: function () {
                    that.loading = true;
                    let paramsList = [];
                    let list = that.dataSource.filter(d => that.selectedRowKeys.some(s => s == d.id));
                    list.map(item => {
                        paramsList.push({
                            meterId: item.meterId,
                            meterType: item.meterType,
                            meterTypeName: item.meterTypeName,
                            operateType: 0,
                            userId: item.userId,
                            userKeyId: item.id,
                            userName: item.userName,
                            wtPriceName: `${item.wtName}(${item.wtTotalPrice}${that.$t('元')})`,
                            userAreaId: item.userAreaId
                        });
                    });
                    postAction(that.url.stopUserByIds, { meterStopRecordDTOList: paramsList }).then((res) => {
                        if (res.success) {
                            that.$message.success(that.$t("报停成功"));
                            that.loadData();
                            that.onClearSelected();
                        } else {
                            that.$message.warning(res.message);
                        }
                    }).finally(() => {
                        that.loading = false;
                    });
                }
            });
        },
        // 销户
        handleCancellation(row) {
            let that = this;
            this.$confirm({
                title: this.$t('提示'),
                content: this.$t('销户后，该表信息所有将在系统内消失，无法正常使用。确定销户？'),
                onOk() {
                    let paramsList = [
                        {
                            meterId: row.meterId,
                            meterType: row.meterType,
                            meterTypeName: row.meterTypeName,
                            operateType: 2,
                            userId: row.userId,
                            userKeyId: row.id,
                            userName: row.userName,
                            wtPriceName: `${row.wtName}(${row.wtTotalPrice}${that.$t('元')})`,
                            userAreaId: row.userAreaId
                        }
                    ];
                    postAction(that.url.logoutUserByIds, { meterStopRecordDTOList: paramsList }).then(res => {
                        if (res.success) {
                            that.$message.success(that.$t("销户成功"));
                            that.loadData();
                        } else {
                            that.$message.warning(res.message);
                        }
                    }).finally(() => {
                        that.loading = false;
                    });
                },
                onCancel() {
                    console.log('Cancel');
                },
            });
        },
        // 标记或取消大用户
        changeImportantFlag(record){
            let params = {
                ...record,
                importantFlag: record.importantFlag == 1? 1:0
            }
            putAction(this.url.edit, params).then((res) => {
                if(res.success){
                    this.$message.success(this.$t("操作成功"));
                    this.loadData();
                }else{
                    this.$message.warning(res.message);
                }
            });
        },
    },
    created() {
        this.$store.commit('SET_LAYOUT_TREE', true)
        this.initColumns();
        this.queryUserPriceCode();
        this.queryUserCaliberList();  // 表口径请求
    }
}
</script>
<style scoped lang="less">
.drawer-bootom-button {
    bottom: 0;
    width: 100%;
    border-top: 1px solid #e8e8e8;
    padding: 10px 16px;
    text-align: left;
    left: 0;
    background: #fff;
    border-radius: 0 0 2px 2px;
}
.qrcodeInfo {
    color: #222;
    margin: 5px 0;
}
</style>
<style scoped>
.my-area-select-tree /deep/ li .ant-tree-node-content-wrapper {
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    white-space: nowrap;
}
</style>
<style scoped>
.table-fixed /deep/ .ant-table-bordered .ant-table-fixed-left table {
    border-right: 1px solid #e8e8e8;
}

.table-fixed /deep/ .resize-table-th {
    position: relative;
}
.table-fixed /deep/ .table-draggable-handle {
    border: 1px solid red;
    height: 100% !important;
    left: auto !important;
    right: -5px;
    cursor: col-resize;
    touch-action: none;
    border: none;
    position: absolute;
    transform: none !important;
    bottom: 0;
}
</style>